module.exports = __webpack_public_path__ + "pdf/this-is-am.cb8d616.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/this-is-am.pdf
// module id = 7hm0
// module chunks = 0